import { TextArea, TextAreaProps } from '@components/textarea';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormTextAreaProps<T = unknown> = FormFieldProps<TextAreaProps, T>;

export function FormTextarea<T>(props: FormTextAreaProps<T>) {
  const formFieldProps = useFormField(props);

  return (
    <TextArea
      {...props}
      {...formFieldProps}
      // Since it's controlled inside a form, we dont want to BOTH
      // 1. supply a defaultValue (in case the user supplied one), and
      // 2. supply a value (from the useFormField props)
      // at the same time. So just unset the defaultValue.
      defaultValue={undefined}
    />
  );
}
